import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  TableHeader,
  Loading,
  Modal,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables, useSelectOption } from "App/hooks";

import {
  defaultDateDisplay,
  defaultToastError,
  formatNumber,
  isNull,
} from "App/utils/helpers";
import FormFilterDaftarPO from "../../../DaftarPo/FormFilterDaftarPO";
import {
  getByFilterPO,
  headCells,
  RenderStatusPoBadge,
  RESET_STATE_FORM_FILTER,
} from "../../../DaftarPo/helpers";
import { SelectIcon } from "App/Assets";
import { TYPE_INSTANCE4 } from "App/constants";

export default function ModalListPo({ setShowModal, handleClickSelect }) {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterPO(formFilter, pages, limit, 0);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });



  return (
    <>
      <Modal title={`CARI PO`} width="70%" show={setShowModal}>
        <div className={classes.root}>
          <Paper
            className={classes.paper}
            style={{
              padding: "1rem",
            }}
          >
            <FormFilterDaftarPO
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              setNewData={setNewData}
              typeButton="button"
              disabledStatus={true}
            />
            <Loading show={loading} />
            <TableDaftarPO
              rows={rows}
              classes={classes}
              handleClickSelect={handleClickSelect}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </Paper>
        </div>
      </Modal>
    </>
  );
}

const TableDaftarPO = ({ rows, classes, handleClickSelect }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const ButtonSelect = ({ id, status, row }) => {
    if (isNull(id) && status) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButtonDatatable
            onClick={() => {
              handleClickSelect(row);
            }}
          >
            <SelectIcon />
          </IconButtonDatatable>
        </div>
      );
    } else {
      return (
      <></>)
    }
  };

  return (
    <TableContainer className="custom-scrollbar">
      <Table
        className={classes.table}
        aria-labelledby="tableTitle"
        size={"medium"}
        aria-label="enhanced table"
      >
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  <ButtonSelect
                    id={row.pembelian_id}
                    status={row?.status}
                    row={row}
                  />
                </TableCell>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">{row?.pembelian_id}</TableCell>
                <TableCell align="left">{row?.nomorPO}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.date)}
                </TableCell>
                <TableCell align="left">{row?.unit}</TableCell>
                <TableCell align="left">{isNull(row?.produsen) ? "-" : row?.produsen}</TableCell>
                <TableCell align="left">{row?.supiler}</TableCell>
                <TableCell align="left">
                  <RenderStatusPoBadge status={row.status_transaksi} />
                </TableCell>
                <TableCell align="left">{row?.processedBy}</TableCell>
                <TableCell align="right">
                  {row.total_harga === null
                    ? "0"
                    : formatNumber(row.total_harga)}
                </TableCell>
                <TableCell align="left">{row?.penerima}</TableCell>
                <TableCell align="left">{row?.createdAt}</TableCell>
                <TableCell align="left">{row?.createdBy}</TableCell>
                <TableCell align="left">{row?.updatedAt}</TableCell>
                <TableCell align="left">{row?.updatedBy}</TableCell>
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
